import { useEffect } from "react";
import { ANCHOR_ATTR, ANCHOR_CSS_VAR, measureAnchorAdHeight } from "@/lib/anchorAd";

/**
 * Keeps --anchor-h (on <html>) equal to the height of Google's bottom anchor ad while the calling component is
 * mounted. Re-measured when the ad appears, resizes or goes away. Nothing is hidden or removed.
 */
export function useAnchorAdOffset() {
  useEffect(() => {
    const root = document.documentElement;
    let raf = 0;
    const update = () => {
      raf = 0;
      const h = measureAnchorAdHeight();
      root.style.setProperty(ANCHOR_CSS_VAR, `${h}px`);
      if (h > 0) root.setAttribute(ANCHOR_ATTR, "");
      else root.removeAttribute(ANCHOR_ATTR);
    };
    const schedule = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };
    update();
    const mo = new MutationObserver(schedule);
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-anchor-shown", "data-anchor-status", "style", "class"],
    });
    window.addEventListener("resize", schedule);
    // a late-filling ad can change height without any DOM mutation we can see
    const timer = window.setInterval(update, 3000);
    return () => {
      mo.disconnect();
      window.removeEventListener("resize", schedule);
      window.clearInterval(timer);
      if (raf) window.cancelAnimationFrame(raf);
      root.style.removeProperty(ANCHOR_CSS_VAR);
      root.removeAttribute(ANCHOR_ATTR);
    };
  }, []);
}
